/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesScorecardsApplicationScorecardsScorecardResponse { 
    playerId?: string;
    playerFirstName?: string;
    playerLastName?: string;
    scorecardId?: string;
    businessEntityId?: number;
    businessEntityType?: string;
    tournamentId?: string;
    tournamentName?: string;
    roundId?: string;
    roundNumber?: number;
    courseId?: string;
    courseName?: string;
    teeBoxId?: string;
    teeboxName?: string;
    startScore?: number;
    finishScore?: number;
    roundScore?: number;
    startPlusMinus?: number;
    finishPlusMinus?: number;
    roundPlusMinus?: number;
    startSfpoints?: number;
    finishSfpoints?: number;
    roundSfpoints?: number;
    roundMatchResult?: number;
    verified?: boolean;
    official?: boolean;
    verifiedOnUtc?: Date;
    officialOnUtc?: Date;
    createdOnUtc?: Date;
    modifiedOnUtc?: Date;
}